import { cargoes } from '../entities/cargoes-sidecar'
import { ICargoType } from '../entities/cargoesData'
import { distance } from '../lib/distance-sidecar'
import { IJob, ITask } from './jobs'
import { jobs } from './jobs-sidecar'
import { jobLogger } from './jobLogger-sidecar'

export function createConsumeCargoTask(
  i: number,
  j: number,
  cargoType: ICargoType,
  allowNextTo: boolean = false,
): ITask {
  return jobs._createTask(i, j, 'consume-cargo', {
    allowFromStack: false,
    cargoType,
    allowNextTo,
  })
}

export function runTaskConsumeCargo(job: IJob, task: ITask) {
  jobLogger.assertTaskType(task, 'consume-cargo')
  let m = jobLogger.assertReserved(job)

  // console.log('consume cargo...')

  // Are we at the right spot?
  if (task.allowNextTo) {
    if (!distance.isNextToIJ(m, task)) {
      jobLogger.failTask(job, task, 'not next to')
      return
    }
  } else {
    if (!distance.isAtIJ(m, task)) {
      jobLogger.failTask(job, task, 'wrong spot')
      return
    }
  }

  let cargoHere = cargoes.findClosestTo(
    m.i,
    m.j,
    (c) => c.data.type == task.cargoType,
  )
  // Cargo went missing
  if (!cargoHere) {
    jobLogger.failTask(job, task, 'lost cargo')
    return
  }

  cargoes.kill(cargoHere)
  return jobLogger.succeedTask(job, task)
}
